import styled from "styled-components";

const Container = styled.div`
  width: 100%;
`;

const AccordionDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px;

  .MuiFormGroup-root {
    border: 1px solid lightgray;
    border-radius: 5px;
    padding-left: 10px;
    width: 100%;
    min-height: 150px;
    height: 150px;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
    overflow: auto;

    &.Mui-error {
      border: 1px solid red !important;
    }
  }

`;

const QuickRanges = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;

  button {
    font: inherit;
    font-size: 13px;
    cursor: pointer;
    border: 1px solid lightgray;
    background: #fff;
    color: ${(props) => props.theme.colors.gray};
    border-radius: 999px;
    padding: 5px 12px;

    &[aria-pressed="true"] {
      background: #e8f0fe;
      border-color: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.primary};
      font-weight: 500;
    }
  }
`;

export {
  Container,
  AccordionDetail,
  QuickRanges
};
